import {inject, injectable} from "inversify";
import {EventEmitter} from "@/modules/base/events";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {LiveMatchHandlerInterface} from "@/modules/match/interfaces";
import LiveMatchEvaluator from "@/modules/match/services/LiveMatchEvaluator";
import {LiveIncidentType, TickType} from "@/modules/match/types";

@injectable()
export default class EnergyMatchHandler implements LiveMatchHandlerInterface {
  constructor(
    @inject(EventEmitter) private em: EventEmitter,
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {
  }

  priority(): number {
    return 0;
  }

  async onFinish(liveMatchEvaluator: LiveMatchEvaluator, tick: TickType) {
  }

  async onIncident(liveMatchEvaluator: LiveMatchEvaluator, tick: LiveIncidentType): Promise<void> {
  }

  async onTick(liveMatchEvaluator: LiveMatchEvaluator, tick: TickType): Promise<void> {
    tick.homePlayers.filter(p => p.lineup).forEach(p => {
      p.energy = Math.max(1, p.energy - this.configRepository.get('match.evaluation.energyReductionPerTick')(p));
    });
    tick.awayPlayers.filter(p => p.lineup).forEach(p => {
      p.energy = Math.max(1, p.energy - this.configRepository.get('match.evaluation.energyReductionPerTick')(p));
    });
  }
}
